import {
  CheckRewardResponse,
  EmptyResponse,
  GetDartsResponse,
  GetRewardRequest,
  GetSurveyLinkResponse,
  PostRewardRequest,
  VerifyReceiptRequest,
  VerifyReceiptResponse,
} from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

export const getDarts = async () => {
  return fetcher(() => http.get<GetDartsResponse>('/products'));
};

// 기존 api 그대로 사용, v1.3으로 이전 X
export const verifyReceipt = async (requestData: VerifyReceiptRequest) => {
  const { data } = await http.post<VerifyReceiptResponse>(
    `${import.meta.env.VITE_SERVER_PAYMENT_LAMDA}inapp/verifyReceiptIdolmaster`,
    requestData,
  );

  return data;
};

export const getReward = async ({ timezone_iana, type }: PostRewardRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>('/rewards', {
      type,
      timezone_iana,
    }),
  );
};

export const checkRewardStatus = async ({
  timezone_iana,
}: GetRewardRequest) => {
  return fetcher(() =>
    http.get<CheckRewardResponse>('/rewards', {
      params: {
        timezone_iana,
      },
    }),
  );
};

export const getSurveyLink = async () => {
  return fetcher(() => http.get<GetSurveyLinkResponse>('/surveys'));
};

// export const testSetUpDarts = async ({
//   email,
//   dart,
// }: {
//   email: string;
//   dart: number;
// }) => {
//   const requestData = {
//     email,
//     dart,
//     gem: 0,
//   };
//   return fetcher(() =>http.post<VerifyReceiptResponse>(
//     '/product/testProduct',
//     requestData,
//   );

//     return { data: res.data, status: res.status };
// };
